import { call, put } from '@redux-saga/core/effects';
import { api, notify, apiErrorHandler } from 'services';
import {
  DeleteCompanyWarehouseAccessActions as Actions,
  DeleteCompanyWarehouseAccessRequestAction as RequestAction,
} from 'store/ducks/companyWarehouseAccesses';

export function* deleteCompanyWarehouseAccessRequest(action: any) {
  const { id, onSuccess, onFailure }: RequestAction = action;
  try {
    yield call(api.delete, `company-warehouse-accesses/${id}`);
    onSuccess && onSuccess();
    notify('success', 'Restrição de armazém desvinculado com sucesso');
    yield put(Actions.success());
  } catch (error) {
    const { errorMessage, validationErrors } = apiErrorHandler(error);
    onFailure && onFailure();
    notify('error', errorMessage);
    yield put(Actions.failure(errorMessage, validationErrors));
  }
}
